import { render, staticRenderFns } from "./ClientData.vue?vue&type=template&id=0340b4dd&scoped=true&lang=pug"
import script from "./ClientData.vue?vue&type=script&lang=js"
export * from "./ClientData.vue?vue&type=script&lang=js"
import style0 from "./ClientData.vue?vue&type=style&index=0&id=0340b4dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0340b4dd",
  null
  
)

export default component.exports